module.exports = __webpack_public_path__ + "static/media/chat_lined.88bcc362.svg";